import React from "react";

import ReactDOM from "react-dom";
import "./ClientUpdate.scss";
import Select from "react-dropdown-select";
import axios from "axios";
import Popup from "../Popup";
import Moment from "react-moment";
import moment, { relativeTimeThreshold } from "moment";
import "moment/locale/pt";

import validator from 'validator';

import DropdownPais from "../Dropdown/DropdownPais";
import DropdownCAE from "../Dropdown/DropdownCAE";
import DropdownCondPag from "../Dropdown/DropdownCondPag";
import DropdownYN from "../Dropdown/DropdownYN";
import DropdownGrpContas from "../Dropdown/DropdownGrpContas";
import DropdownContaConcil from "../Dropdown/DropdownContaConcil";
import DropdownGrpCli from "../Dropdown/DropdownGrpCli";
import DropdownClassFiscal from "../Dropdown/DropdownClassFiscal";
import Cookies from "js-cookie";
import logoLong from "../../logoISQ.gif";

import logo from "../../ISQ-Logo.jpg";
import App from "../App";

import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';

import Parser from 'fast-xml-parser';
import { checkVAT, countries } from 'jsvat';
import Axios from "axios";




class ClientNew extends React.Component {

  constructor(props) {
    super(props);


    this.state = {
      clientsList: [],
      id: 0,
      idPedido:"",
      idCliente:"",
      nome: "",
      nome_2: "",
      morada: "",
      morada_2: "",
      cd_post: "",
      localidade: "",
      pais: "PT",
      nif: "",
      grp_cont: "",
      telefone: "",
      fax: "",
      e_mail: "",
      site: "",
      observacoes: "",
      telemovel: "",
      conta_concil: "",
      sede: "",
      sector_activ: "",
      grp_clientes: "",
      taxkd: "",
      cod_cert_prm: "",
      grp_economico: "",
      cae: "",
      lim_cred: 0,
      mail_contato: "",
      banda: 0,
      fat_ele: "",
      fin_nome_contato: "",
      fin_tel_contato: "",
      fin_mail_contato: "",
      fin_horario_forn: "",
      viesButton : true,
      submitButton : true,
      zterm: "",
      concelho: "",
      buttonOff: true,
      popupShow: false,
      popupTitle: "",
      popupLines: [],
      padding2 : "",
      padding1 : "",
      EmailResponsavelProposta : Cookies.get("username") + "@isq.pt"

    };

    this.handleChange = this.handleChange.bind(this);
    this.submitClient = this.submitClient.bind(this);

    this.changePopupStatus = this.changePopupStatus.bind(this);
    this.viesInteraction = this.viesInteraction.bind(this);

    this.supportedJsvatCountries = [
      "Andorra","Austria","Belgium","Brazil","Bulgaria","Switzerland",
      "Cyprus","Czech Republic","Germany","Denmark","Greece","Spain",
      "Europe","Estonia","Finland","France","United Kingdom","Croatia",
      "Hungary","Ireland","Italy","Latvia","Lithuania","Luxembourg",
      "Malta","Netherlands","Norway","Poland","Portugal","Romania",
      "Russia Federation","Serbia","Slovenia","Slovakia republic","Sweden"
    ];

    this.countries = new Array();
    Axios.get(`https://${process.env.REACT_APP_API_IP}/api/country`)
      .then(res => {
        res.data.forEach(element => {
          var countryObj = {
            code: element.countryCode,
            name: element.name
          };
          this.countries.push(countryObj);
        });
      })
      .catch(err => {
        console.log(err);
      });

  }



  async submitClient() {

    // NIF (VAT)
    if (!!this.state.nif && this.state.nif != "") {
      // 1 - Country validation (for countries supported by the framework)
      try {
        var selectedCountry = this.countries.find(x => x.code.toLowerCase() == this.state.pais.toLowerCase());
        if (selectedCountry != null && this.supportedJsvatCountries.some(x => x.toLowerCase() == selectedCountry.name.toLowerCase())) {
          var vatCheckResult = checkVAT(this.state.pais + this.state.nif, countries);
          if (!vatCheckResult.isValid) {
            this.setState({
              popupShow: true, 
              popupTitle: "Error" ,
              popupLines: ["O Nif inserido não corresponde ao país selecionado"]});
            return;
          }
        }
      } catch (error) {
        console.error(error);
      }

      // 2 - Check if already exists client with the nif
      try {
        let res = await Axios({
          url: `https://${process.env.REACT_APP_API_IP}/api/clients/cantakevat/${this.state.nif}`,
          method: 'get'
        });
        if (res.status == 200) {
            if (res.data == false) {
              this.setState({
                popupShow: true,
                popupTitle: "Error" ,
                popupLines: ["O Nif inserido já se encontra atribuído"]});
              return;
            }
        }
      } catch (error) {
        console.error(error);
      }
    }


    // CODIGO POSTAL
    if (!!this.state.cd_post && this.state.cd_post != "") {
      // 1 - Country validation
      try {
        const postalCodes = require('postal-codes-js');
        if (postalCodes.validate(this.state.pais, this.state.cd_post) != true) {
          this.setState({
            popupShow: true,
            popupTitle: "Error" ,
            popupLines: ["O código postal inserido não corresponde ao país selecionado"]});
          return;
        }
      } catch (error) {
        console.error(error);
      }

      // 2 - Portuguese code validation
      if (this.state.pais == 'PT') {
        try {
          let res = await Axios({
            url: `https://${process.env.REACT_APP_API_IP}/api/ctt/${this.state.cd_post}`,
            method: 'get'
          });
          if (res.status = 200) {
            let jsonObj = Parser.parse(res.data, {ignoreAttributes:false });
            if (jsonObj.hasOwnProperty('Erro') && !jsonObj.Erro.hasOwnProperty('Result')) {
              this.setState({
                popupShow: true,
                popupTitle: "Error" ,
                popupLines: ["O código postal inserido não é válido"]});
              return;
            }
            else {
                var idlo_4digits = "";
                if (jsonObj.hasOwnProperty('OK') && jsonObj.OK.Localidade['@_idlo'] != null) {
                    idlo_4digits = jsonObj.OK.Localidade['@_idlo'];
                }
                else if (jsonObj.hasOwnProperty('OK') && jsonObj.OK.Localidade.length > 1) {
                    idlo_4digits = jsonObj.OK.Localidade[0]['@_idlo'];
                }
                else if (jsonObj.hasOwnProperty('Erro') && jsonObj.Erro.Localidade['@_idlo'] != null) {
                    idlo_4digits = jsonObj.Erro.Localidade['@_idlo'];
                }
                else if (jsonObj.hasOwnProperty('Erro') && jsonObj.Erro.Localidade.length > 1) {
                    idlo_4digits = jsonObj.Erro.Localidade[0]['@_idlo'];
                }
                idlo_4digits = idlo_4digits.substr(idlo_4digits.length - 4);
                this.state.concelho = idlo_4digits;
            }
          }
        } catch (error) {
          console.error(error);
        }
      }
    }

    console.log(this.state.concelho);
    console.log(this.state.fat_ele);
    console.log(!this.state.mail_contato );
    console.log(!!!this.state.mail_contato );
    if (this.state.fat_ele == "X" && !this.state.mail_contato ) {
			this.setState({
				popupShow: true,
				popupTitle: "Error" ,
				popupLines: ["No caso optar por fatura eletrónica deve inserir também o e-mail"],
			  });
			return
    }
    if (!validator.isEmail(this.state.e_mail)) {
			this.setState({
				popupShow: true,
				popupTitle: "Error" ,
				popupLines: ["Email do cliente Inválido"],
			  });
			return
    }

    if ( !!this.state.fin_mail_contato && !validator.isEmail(this.state.fin_mail_contato)) {
			this.setState({
				popupShow: true,
				popupTitle: "Error" ,
				popupLines: ["Email do contato financeiro inválido"],
			  });
			return
		}

    if (!!this.state.mail_contato&  !validator.isEmail(this.state.mail_contato)) {
			this.setState({
				popupShow: true,
				popupTitle: "Error" ,
				popupLines: ["Email da fatura eletrónica errada"],
			  });
			return
		}

    let objToSend = this.state;
    delete objToSend.clientsList;
    delete objToSend.buttonOff;
    delete objToSend.popupShow;
    delete objToSend.popupTitle;
    delete objToSend.popupLines;
    delete objToSend.sector_activ;
    console.log(objToSend);
    if (objToSend.lim_cred !== null && objToSend.lim_cred.length > 0) {
      objToSend.lim_cred = objToSend.lim_cred.replace(",", ".");
    }
    objToSend.lim_cred = parseFloat(objToSend.lim_cred);
    objToSend.banda = parseInt(objToSend.banda);

    this.setState({
      popupShow: true,
      popupTitle: "A enviar proposta",
      popupLines: ["Por favor aguarde"]
    });
    await axios
      .post(`https://${process.env.REACT_APP_API_IP}/api/clients`, objToSend)
      .then(res => {
        this.setState({
          popupLines: ["Cliente enviado com sucesso"]
        });

        window.location.reload();

      })
      .catch(error => {
        console.log("Erro ao enviar:");
        console.log(error.response);

        if (error.response.status === 500) {
          this.setState({
            popupTitle: "Erro ao enviar",
            popupLines: [error.response.data.title]
          });
        } else if (error.response.status === 400) {


        } else {
          this.setState({
            popupTitle: "Erro ao envia",
            popupLines: "Contacte o departamento responsável"
          });
        }

      });
  }

  verigyNifInSap (){

    console.log(this.state.nif);

    axios
   .get(`https://${process.env.REACT_APP_API_IP}/api/sap/verifywithnif/` +   this.state.pais +  this.state.nif)
   .then(res => {


     var warning = <font color="red"> O NIF {this.state.nif} já existe em SAP</font>
     ReactDOM.render(warning, document.getElementById('warning'));
     return true;

   })
   .catch(error => {
     var warning = <font color="red"> </font>
     ReactDOM.render(warning, document.getElementById('warning'));
     return false;
   });

}
  componentDidMount() {

    moment.locale("pt");
    this.setState({
      lastupdateby: "-",
      lastupdatetime: "0000-00-00T00:00:00"
    });
  }





  handleChange(event) {
    const inputName = event.target.name;


    this.setState({
      buttonOff: false,
      [inputName]: event.target.value
    } , () => {




      if(!!this.state.e_mail && !!this.state.nome && !! this.state.nif){

        this.setState({

          submitButton : false
        });




      }else{
        this.setState({

          submitButton : true
        });


      }
    });



  }

  changePopupStatus() {
    this.setState({
      popupShow: !this.state.popupShow,
      viesModalState: false
    });
  }

  async viesInteraction() {

    console.log(await this.verigyNifInSap() ? "Encontrou" : "Não encontrou" );
    this.setState({
      popupShow: true,
      popupTitle: "A validar NIF",
      popupLines: ["Por favor aguarde"]
    });
    await axios
      .post(
        `https://${process.env.REACT_APP_API_IP}/api/clients/nif/validate`,
        {
          countryCode: this.state.pais,
          vatCode: this.state.nif
        }
      )
      .then(res => {
        console.log(res);
        if (res.data.valid) {
          this.setState({
            popupTitle: "NIF Válido",
            popupLines: [
              "Nome: " + res.data.name,
              "Morada: " + res.data.address
            ],
            viesModalState: true
          });
        } else {
          this.setState({
            popupTitle: "Não há informação no VIES do nif: " + this.state.nif,
            popupLines: ["Sem Informação"],
            viesModalState: true
          });
        }
      })
      .catch(err => {
        console.log(err.response);
        this.setState({
          popupTitle: "Não há informação no VIES do nif: " + this.state.nif,
          popupLines: ["Sem Informação"],
        });
      });
  }

  parseViesAddress(address) {
    console.log(address);
    return [address];
  }

  render() {


    if(Cookies.get("username") == undefined){

        this.state.padding1 = "col-sm-10";
        this.state.padding2 =  "col-1";



    }else{

        this.state.padding1 = "col-sm-12";
        this.state.padding2 =  "";


    }


    return(

      <React.Fragment>
        <Popup
          viesModal={this.state.viesModalState}
          updateStatus={this.changePopupStatus}
          useViesData={this.useDataFromVies}
          popupShow={this.state.popupShow}
          popupTitle={this.state.popupTitle}
          popupLines={this.state.popupLines}
        ></Popup>

					<div className="app-container app-theme-white body-tabs-shadow fixed-sidebar fixed-header center">
						<div className="app-header header-shadow " >
							<div className="app-header__logo">
								<img
									style={{ height: 50 }}
									src={logoLong}
									alt="ISQ"
								/>
							</div>
						</div>
        <div class = 'row'>
            <div id='espaco' class={
      this.state.padding2
      }>

            </div>

        <div id='dados' class={
      this.state.padding1
      }>

    <div id = "dadosGerais">

    	<div style={{ paddingLeft: 0 }}>


							<h4
								className="sectionTitle"
								style={{ paddingTop: 80 }}>
								Dados Gerais
							</h4></div>

              <div id = "warning"></div>
        <br></br>

        <div className="pendingRow">
          <div className="clientSingleField col4">

            <label >NIF  <font color="red">*</font> </label>

            <br />
            <input
              type="text"
              className="form-control"
              value={this.state.nif || ""}
              onChange={this.handleChange}
              name="nif"
              maxLength="20"

            />
          </div>
          <div className="clientSingleField col4">
            <label>País</label>
            <br />
            <select
              className="custom-select"

              value={this.state.pais}
              onChange={this.handleChange}
              name="pais"
            >
              <DropdownPais />
            </select>
          </div>
          <div className="clientSingleField col4">
            <label>&nbsp;</label>
            <br />
            <button

              disabled={!this.state.viesButton}
              style={{ height: 28 }}
              onClick={this.viesInteraction}
              className="mb-2 mr-2 btn btn-secondary"
            >
              Validar
            </button>
          </div>
        </div>
        <div className="pendingRow">
          <div className="clientSingleField col2">
            <label>Nome <font color="red">*</font></label>
            <br />
            <input
             className="form-control"
              type="text"
              value={this.state.nome || ""}
              onChange={this.handleChange}
              name="nome"
              maxLength="40"
            />
          </div>
          <div className="clientSingleField col2">
            <label>Nome Complementar</label>
            <br />
            <input
             className="form-control"
              type="text"
              value={this.state.nome_2 || ""}
              onChange={this.handleChange}
              name="nome_2"
              maxLength="40"
            />
          </div>
        </div>
        <div className="pendingRow">
          <div className="clientSingleField col2">
            <label>Morada</label>
            <br />
            <input
             className="form-control"
              type="text"
              value={this.state.morada || ""}
              onChange={this.handleChange}
              name="morada"
              maxLength="60"
            />
          </div>
          <div className="clientSingleField col2">
            <label>Morada Complementar</label>
            <br />
            <input
             className="form-control"
              type="text"
              value={this.state.morada_2 || ""}
              onChange={this.handleChange}
              name="morada_2"
              maxLength="40"
            />
          </div>
        </div>
        <div className="pendingRow">
          <div className="clientSingleField col2">
            <label>Código Postal</label>
            <br />
            <input
             className="form-control"
              type="text"
              value={this.state.cd_post || ""}
              onChange={this.handleChange}
              name="cd_post"
              maxLength="10"
            />
          </div>
          <div className="clientSingleField col2">
            <label>Localidade</label>
            <br />
            <input
             className="form-control"
              type="text"
              value={this.state.localidade || ""}
              onChange={this.handleChange}
              name="localidade"
              maxLength="40"
            />
          </div>

        </div>
        <div className="pendingRow">
          <div className="clientSingleField col3">
            <label>Telefone</label>
            <br />
            <input
             className="form-control"
              type="text"
              value={this.state.telefone || ""}
              onChange={this.handleChange}
              name="telefone"
              maxLength="30"
            />
          </div>
          <div className="clientSingleField col3">
            <label>Telemóvel</label>
            <br />
            <input
             className="form-control"
              type="text"
              value={this.state.telemovel || ""}
              onChange={this.handleChange}
              name="telemovel"
              maxLength="30"
            />
          </div>
          <div className="clientSingleField col3">
            <label>Fax</label>
            <br />
            <input
             className="form-control"
              type="text"
              value={this.state.fax || ""}
              onChange={this.handleChange}
              name="fax"
              maxLength="30"
            />
          </div>
        </div>
        <div className="pendingRow">
          <div className="clientSingleField col3">
            <label>Email <font color="red">*</font></label>
            <br />
            <input
             className="form-control"
              type="text"
              value={this.state.e_mail || ""}
              onChange={this.handleChange}
              name="e_mail"
              maxLength="241"
            />
          </div>
          <div className="clientSingleField col3">
            <label>Site</label>
            <br />
            <input
             className="form-control"
              type="text"
              value={this.state.site || ""}
              onChange={this.handleChange}
              name="site"
              maxLength="132"
            />
          </div>
          <div className="clientSingleField col3">
            <label>Observações</label>
            <br />
            <input
             className="form-control"
              type="text"
              value={this.state.observacoes || ""}
              onChange={this.handleChange}
              name="observacoes"
              maxLength="50"
            />
          </div>
          </div>
        </div>
        <br></br>
        <h4 className="sectionTitle">Contactos Financeiros</h4>
        <div className="pendingRow">
          <div className="clientSingleField col3">
            <label>Nome</label>
            <br />
            <input
             className="form-control"
              type="text"
              value={this.state.fin_nome_contato || ""}
              onChange={this.handleChange}
              name="fin_nome_contato"
              maxLength="40"
            />
          </div>
          <div className="clientSingleField col3">
            <label>Telefone</label>
            <br />
            <input
             className="form-control"
              type="text"
              value={this.state.fin_tel_contato || ""}
              onChange={this.handleChange}
              name="fin_tel_contato"
              maxLength="30"
            />
          </div>
          <div className="clientSingleField col3">
            <label>Email</label>
            <br />
            <input
             className="form-control"
              type="text"
              value={this.state.fin_mail_contato || ""}
              onChange={this.handleChange}
              name="fin_mail_contato"
              maxLength="241"
            />
          </div>
        </div>
        <div className="pendingRow">
          <div className="clientSingleField col1">
            <label>Horário de atendimento</label>
            <br />
            <input
             className="form-control"
              type="text"
              value={this.state.fin_horario_forn || ""}
              onChange={this.handleChange}
              name="fin_horario_forn"
              maxLength="132"
            />
          </div>
        </div>
        <br></br>
        <h4 className="sectionTitle">Dados de Faturação</h4>
        <div className="pendingRow">

          <div className="clientSingleField col3">
            <label>Código da Certidão Permanente</label>
            <br />
            <input
             className="form-control"
              type="text"
              value={this.state.cod_cert_prm || ""}
              onChange={this.handleChange}
              name="cod_cert_prm"
              maxLength="20"
            />
          </div>
          <div className="clientSingleField col3">
            <label>Grupo Económico</label>
            <br />
            <input
             className="form-control"
              type="text"
              value={this.state.grp_economico || ""}
              onChange={this.handleChange}
              name="grp_economico"
              maxLength="10"
            />
          </div>

          <div className="clientSingleField col3">
            <label>CAE</label>
            <br />
            <select
             className="form-control"

              value={this.state.cae}
              onChange={this.handleChange}
              name="cae"
            >
              <DropdownCAE />
            </select>
          </div>
        </div>
        <div className="pendingRow">



        </div>
        <div className="pendingRow">

          <div className="clientSingleField col3">
            <label>Com Faturação Eletrónica?</label>
            <br />
            <select
             className="form-control"

              value={this.state.fat_ele}
              onChange={this.handleChange}
              name="fat_ele"
            >
              <DropdownYN />
            </select>
          </div>
          <div className="clientSingleField col3">
            <label>Email de Faturação Eletrónica</label>
            <br />
            <input
             className="form-control"
              type="text"
              value={this.state.mail_contato || ""}
              onChange={this.handleChange}
              name="mail_contato"
              maxLength="241"
            />
          </div>
        </div>
        <br></br>


        <br></br>
        <br></br>
        <div className="pendingRow">
          <div className="clientSingleField col15">

          </div>
          <div
            style={{ marginRight: "auto" }}
            className="clientSingleField col4"
          >

            <button

              style={{ float: "right" }}
              onClick={this.submitClient}
              className="mb-2 mr-2 btn btn-primary"
              disabled = {this.state.submitButton}
            >
            Enviar pedido de cliente
            </button>{" "}


          </div>

        </div></div>
        </div> </div>

      </React.Fragment>
    )
  }
}

export default ClientNew;
